/* eslint-disable camelcase */

import capone from './kittycash/kc-al-capone.png';
import audrey from './kittycash/kc-audrey.png';
import illuminati from './kittycash/kc-illuminati.png';
import jackson from './kittycash/kc-jackson.png';
import jjjenkins from './kittycash/kc-jjjenkins.png';
import magician from './kittycash/kc-magician.png';
import satoshi from './kittycash/kc-satoshi.png';
import skykitty from './kittycash/kc-skykitty.png';
import skywhisker from './kittycash/kc-skywhisker.png';
import smurfette from './kittycash/kc-smurfette.png';
import stevejobs from './kittycash/kc-steve-jobs.png';
import synth from './kittycash/kc-synth.png';
import thor from './kittycash/kc-thor.png';
import trump from './kittycash/kc-trump.png';

// popular
import p_illuminati from './popular/popular-illuminati.png';
import p_john from './popular/popular-john.png';
import p_rudi from './popular/popular-rudi.png';
import p_skycoin_white from './popular/popular-skycoin-white.png';
import p_skycoin from './popular/popular-skycoin.png';
import p_soros from './popular/popular-soros.png';
import p_synth from './popular/popular-synth.png';


export const kc = [
  {
    name: 'capone',
    src: capone,
  },
  {
    name: 'audrey',
    src: audrey,
  },
  {
    name: 'illuminati',
    src: illuminati,
  },
  {
    name: 'jackson',
    src: jackson,
  },
  {
    name: 'jjjenkins',
    src: jjjenkins,
  },
  {
    name: 'magician',
    src: magician,
  },
  {
    name: 'satoshi',
    src: satoshi,
  },
  {
    name: 'skykitty',
    src: skykitty,
  },
  {
    name: 'skywhisker',
    src: skywhisker,
  },
  {
    name: 'smurfette',
    src: smurfette,
  },
  {
    name: 'stevejobs',
    src: stevejobs,
  },
  {
    name: 'synth',
    src: synth,
  },
  {
    name: 'thor',
    src: thor,
  },
  {
    name: 'trump',
    src: trump,
  },
];

export const popular = [
  {
    name: 'p_illuminati',
    src: p_illuminati,
  },
  {
    name: 'p_john',
    src: p_john,
  },
  {
    name: 'p_rudi',
    src: p_rudi,
  },
  {
    name: 'p_skycoin_white',
    src: p_skycoin_white,
  },
  {
    name: 'p_skycoin',
    src: p_skycoin,
  },
  {
    name: 'p_soros',
    src: p_soros,
  },
  {
    name: 'p_synth',
    src: p_synth,
  },
];



// WEBPACK FOOTER //
// ./src/components/QRCode/images/index.js